// extracted by mini-css-extract-plugin
export var container = "header-module--container--XLnQW";
export var dropdownwidth = "header-module--dropdownwidth---TUjc";
export var fontSize = "header-module--fontSize--rs7zB";
export var header = "header-module--header--Zms1V";
export var logo = "header-module--logo--mTLiM";
export var nav = "header-module--nav--e8OJ3";
export var navLink = "header-module--nav-link--SkCii";
export var navbarLight = "header-module--navbar-light--zF++q";
export var navbarNav = "header-module--navbar-nav--a-MIh";
export var navbarStyle = "header-module--navbarStyle--Zymh6";
export var searchButton = "header-module--searchButton--FaX7C";
export var topp = "header-module--topp--cLUqW";
export var whiteNavbar = "header-module--whiteNavbar--bcNq6";